<template>
  <div class="investment-experience data-validate">
    <div class="validate-top">
      <div class="top-left">
        <span class="title">{{$t('User.investExp')}}</span>
      </div>
    </div>
    <el-row>
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-row class="left-row">
          <el-col :xs="24">
            <div class="buessType investExp-col">
              <span
                class="left-span"
              >
                  {{ $t('User.worlSta') }}：
              </span>
              <span>
                  {{ worlSta }}
              </span>
            </div>
          </el-col>
          <el-col :xs="24">
            <div class="buessType investExp-col">
                                      <span
                                        class="left-span"
                                      >
                                          {{$t('User.income')}}：
                                      </span>
              <span>
                                          {{income}}
                                      </span>
            </div>
          </el-col>
          <el-col :xs="24">
            <div class="buessType investExp-col">
                                      <span
                                        class="left-span"
                                      >
                                          {{$t('User.curAsset')}}：
                                      </span>
              <span>
                                          {{runAssets}}
                                      </span>
            </div>
          </el-col>
          <el-col :xs="24">
            <div class="buessType investExp-col">
                                      <span
                                        class="left-span"
                                      >
                                          {{$t('Investment_objective')}}：
                                      </span>
              <span>
                                          {{invTargetIs}}
                                      </span>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
        <el-row class="right-row">
          <el-col :xs="24">
            <div class="buessType investExp-col">
                            <span
                              class="left-span"
                            >
                                {{ $t('User.industry') }}：
                            </span>
              <span>
                                {{ industry }}
                            </span>
            </div>
          </el-col>
          <el-col :xs="24">
            <div class="buessType investExp-col">
                            <span
                              class="left-span"
                            >
                                {{ $t('User.netAsset') }}：
                            </span>
              <span>
                                {{ Assets }}
                            </span>
            </div>
          </el-col>
          <el-col :xs="24">
            <div class="buessType investExp-col">
                            <span
                              class="left-span"
                            >
                                {{ $t('User.fundsSource') }}：
                            </span>
              <span>
                                {{ fundsSource }}
                            </span>
            </div>
          </el-col>
          <el-col :xs="24">
            <div class="buessType investExp-col">
                            <span
                              class="left-span"
                            >
                                CFDs {{ $t('Transaction_history') }}：
                            </span>
              <span>
                                {{ hadFx }}
                            </span>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { workList } from '@/assets/codelist/workList';
import { industryList } from '@/assets/codelist/industryList';
import { incomeList } from '@/assets/codelist/incomeList';
import { assetsList } from '@/assets/codelist/assetsList';
import { fundsSourceList } from '@/assets/codelist/fundsSourceList';
import { invTargetList } from '@/assets/codelist/invTargetList';

export default {
  name: "investmentExperience",
  components: {},
  props: {
    allData: {
      type: Object,
      default() {
        return {
          identifyStatus: '',
          idType: '',
        }
      },
    },
  },
  data() {
    return {
      buessType: '',
      openAim: '',
      understand: '',

      workList: [],
      industryList: [],
      incomeList: [],
      assetsList: [],
      fundsSourceList: [],
      fundsSource: '',
      invTargetIs: '',
      invTargetList: [],
    }
  },
  created() {
    this.workList = workList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.industryList = industryList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.incomeList = incomeList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.assetsList = assetsList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.fundsSourceList = fundsSourceList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
    this.invTargetList = invTargetList.map(item => ({
      ...item,
      label: this.$t(item.label)
    }));
  },
  watch: {
    allData(news, olds) {
      if (news.custStatus != 1 && news.custStatus != 10) {
        this.getFundsSource();
        this.getInvTargetIs();
      }
    }
  },
  computed: {
    worlSta() {
      let text = '-';
      for (let i = 0; i < this.workList.length; i++) {
        if ((+this.workList[i].value) == this.allData.empStatus) {
          text = this.workList[i].label;
          break;
        }
      }
      return text;
    },
    industry() {
      let text = '-';
      for (let i = 0; i < this.industryList.length; i++) {
        if (this.industryList[i].value == this.allData.industry) {
          text = this.industryList[i].label;
          break;
        }
      }
      return text;
    },
    income() {
      let text = '-';
      for (let i = 0; i < this.incomeList.length; i++) {
        if (this.incomeList[i].value == this.allData.annualIncome) {
          text = this.incomeList[i].label;
          break;
        }
      }
      return text;
    },
    Assets() {
      let text = '-';
      for (let i = 0; i < this.assetsList.length; i++) {
        if (this.assetsList[i].value == this.allData.netAsset) {
          text = this.assetsList[i].label;
          break;
        }
      }
      return text;
    },
    runAssets() {
      let text = '-';
      for (let i = 0; i < this.assetsList.length; i++) {
        if (this.assetsList[i].value == this.allData.curAsset) {
          text = this.assetsList[i].label;
          break;
        }
      }
      return text;
    },
    hadFx() {
      if (this.allData.hadFx == 1) {
        return this.$t('root.yes');
      } else if (this.allData.hadFx) {
        return this.$t('root.no');
      } else {
        return '-'
      }
    },
  },
  methods: {
    getFundsSource() {
      let totalStrArr = [];
      let strArr = null;
      if (this.allData && this.allData.fundsSource) {
        strArr = this.allData.fundsSource.split(',');
      }
      for (let i = 0; i < this.fundsSourceList.length; i++) {
        for (let j = 0; j < strArr.length; j++) {
          if (this.fundsSourceList[i].value == strArr[j]) {
            totalStrArr.push(this.fundsSourceList[i].label);
          }
        }
      }
      this.fundsSource = totalStrArr.join(',');
    },
    getInvTargetIs() {
      let totalStrArr = []
      let strArr = null;
      if (this.allData && this.allData.invTarget) {
        strArr = this.allData.invTarget.split(',');
      }
      for (let i = 0; i < this.invTargetList.length; i++) {
        for (let j = 0; j < strArr.length; j++) {
          if (this.invTargetList[i].value == strArr[j]) {
            totalStrArr.push(this.invTargetList[i].label);
          }
        }
      }
      this.invTargetIs = totalStrArr.join(',');
    },
  },
}
</script>

<style lang="scss" scoped>
.investment-experience {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 24px;

  .investExp-col {
    margin-bottom: 10px;
  }

  .validate-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .top-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

  }

  .tag-box-investment-experience {
    display: inline-block;
    padding: 2px 5px;
    border-radius: 15px;
    margin-left: 10px;
  }

  .left-box {
    .data-line {
      .text-box {
        text-align: right;
        color: #A29FAE;
        font-size: 14px;
      }

      .data-box {
        text-align: left;
        color: #5E5873;
        font-size: 14px;
      }
    }
  }

  .buessType {
    font-size: 14px;
    .left-span {
      color: #A29FAE;
    }
  }

  .right-col {
    .data-line {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
    }

    .text-box {
      margin-right: 15px;
      color: #A29FAE;
    }

    .id-img-el {
      width: 120px;
      height: 70px;
      margin-right: 10px;
    }
  }
}
</style>
